// React-Screen CScreenSaver - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026: React rendert die beiden Bilder selbst, die
// Layout-XML LYT_screenSaver.xml wird nicht mehr gelesen. Die Methoden sind
// weiter ueber spec.legacyMethods WOERTLICH uebernommen (Bridge-Vertrag 8) -
// sie arbeiten ueber components.cameraImage/posysseus, und diese Namen legt
// spec.mountLegacy nach dem Mount wieder an.
import { defineReactScreen } from '../bridge.js';
import { CImage } from '../../components/image.js';

const legacy = {};

// (Der urspruengliche prepare() mit createChildrenFromXML stand hier als
// auskommentierter Block. Entfernt am 23.8.2026 - der Screen liest die
// LYT_screenSaver.xml nicht mehr, und ein Kommentar, der etwas anderes
// behauptet, ist schlimmer als keiner. Der Originalcode steht in der
// Git-Historie.)
legacy.prepare = function() {


    var screensaverimage = POS.EnvProperties["SCREENSAVERIMAGE"];

    if (screensaverimage && screensaverimage.indexOf('video') > -1) {

        this.visible = true;
        var me = this;
        /*      this.properties.events.onMousedown = this.close;
        this.properties.events.onKeypress = this.close;
        this.properties.attributes.onMousedown_parameter_0 = this.id;
        this.properties.attributes.onKeypress_parameter_0 = this.id;
*/
        var removeScreenSaver = function() {
            $('#videoscreensaver').remove();
            me.visible = false;
            me.removeMe();
            log.add(3, "Info", "Screen saver disabled", "");
            POS.sessions.hideCurrentSession();
            POS.events.applyTS = true;
            $.when(execute("sudo /bin/bash /home/pos/etc/scripts/stopFFServer.sh", 1000)).always(function(result) {});
        }

        var viddiv = $('<div id="videoscreensaver">').css({
            'position': 'absolute',
            'min-width': "100%",
            'min-height': "106%",
            'width': "auto",
            'height': "auto",
            'z-index': 99,
        })

        $('body').append(viddiv);
        viddiv.click(removeScreenSaver);

        var createVidDiv = function(src) {
            setTimeout(function() {
                var vid = $('<video src="' + src + '" autoplay="autoplay">').css({
                    'position': 'absolute',
                    'min-width': "100%",
                    'min-height': "106%",
                    'width': "auto",
                    'height': "auto",
                    'z-index': 100,
                })
                viddiv.append(vid);
                $('video').click(removeScreenSaver);
            }, 1000);
        }

        var src = screensaverimage.substring(6);
        //if (src.indexOf('rtsp') > -1) {
        $.when(execute("sudo /bin/bash /home/pos/etc/scripts/startFFServer.sh " + src, 5000)).always(function(result) {
            console.log(result);
            src = 'http://127.0.0.1:8090/cam.webm';
            createVidDiv(src);
        });

        /*} else {
            createVidDiv(src);
        }*/
        this.prepared = true;

    } else {
        // Frueher: createChildrenFromXML(LYT_screenSaver.xml). Die beiden
        // Bilder rendert jetzt React; updateImage() zieht spec.mountLegacy
        // nach, sobald sie im DOM stehen (hier gibt es sie noch nicht).
        this.visible = true;

        this.updateRate = 10; // seconds
        //this.updateImageId = window.setTimeout(this.updateImage, this.updateRate * 1000, this.id);

        this.properties.events.onMousedown = this.close;
        this.properties.events.onKeypress = this.close;
        this.properties.attributes.onMousedown_parameter_0 = this.id;
        this.properties.attributes.onKeypress_parameter_0 = this.id;

        log.add(3, "Info", "Screen saver enabled", "");

        this.prepared = true;
    }

}


legacy.updateImage = function(id) {
    var me = POS.getComponentById(id);

    //  var d = new Date();

    //var newImage = POS.EnvProperties["SCREENSAVERIMAGE"] + "?x=" + d;

    //me.components.cameraImage.properties.attributes.src = newImage;
    /*  var unixtime = parseInt(d / 1000) - 5;
      var file = "img" + unixtime + ".0.jpg";
      var file2 = "/parspace/" + file.substring(0, 12);*/
    fs.readdir("parspace/background/", function(err, files) {
        if (err == null && files.length > 0) {
            //        me.components.cameraImage.properties.attributes.src = "parspace/" + files[files.length - 2];
            $("img[name='CImage:" + me.components.cameraImage.id + "']").attr("src", "parspace/background/" + files[0] + "?" + Date.now());

        }
    });
    /*me.components.cameraImage.properties.attributes.src = "file:///parspace/background/cache.jpg";
    me.components.cameraImage.reAttribute();*/
    //me.components.cameraImage.properties.attributes.src = "file:///parspace/background/background.jpg";
    //me.components.cameraImage.reAttribute();
    //      }
    //me.updateImageId = window.setTimeout(me.updateImage, me.updateRate * 1000, id);
    //});
    //  var file="/parspace/img1495872472.0.jpg";
    //  file = /parspace/"/parspace/img1478692308.5.jpg";
    /*fs.stat(file, function(err, stat) {
        if (err == null && stat.size > 5) {
            me.components.cameraImage.properties.attributes.src = file;
            me.components.cameraImage.reAttribute();
        }
        //me.updateImageId = window.setTimeout(me.updateImage, me.updateRate * 1000, id);
    });*/

    me.updateImageId = window.setTimeout(me.updateImage, me.updateRate * 1000, id);
}

/*
    legacy.updateImage = function(id) {
        var me = POS.getComponentById(id);

        var d = new Date();

        var newImage = POS.EnvProperties["SCREENSAVERIMAGE"] + "?x=" + d;

        me.components.cameraImage.properties.attributes.src = newImage;
        me.components.cameraImage.reAttribute();
        me.updateImageId = window.setTimeout(me.updateImage, me.updateRate * 1000, id);

    }
*/
legacy.rePosition = function(id) {
    var me = POS.getComponentById(id);

    if (me.visible == false)
        return;

    if (!me.turnImage || me.turnImage == "camera") {
        var newPos1 = me.newPosition(640, 480, 1024, 768);
        me.components.cameraImage.properties.styles.left = newPos1[0] / 1024 + "%";
        me.components.cameraImage.properties.styles.top = newPos1[1] / 800 + "%";
        me.components.cameraImage.reStyle();
        me.turnImage = "pos";
    } else if (me.turnImage == "pos") {
        var newPos2 = me.newPosition(640, 480, 1024, 768);
        me.components.posysseus.properties.styles.left = newPos2[0] / 1024 + "%";
        me.components.posysseus.properties.styles.top = newPos2[1] / 1024 + "%";
        me.components.posysseus.reStyle();
        me.turnImage = "camera";
    }

    setTimeout(me.rePosition, 5000, me.id);
}

legacy.movePosysseus = function(id) {
    var me = POS.getComponentById(id);

    if (me.surfing == false) {
        if (getRandomNumber(0, 500) == 1) {
            var newPos = me.newPosition(347, 357, 0, 600);
            me.surfing = true;
            left = -347;
            top = this.currenty = newPos[1];
        }
    } else {
        var left = Number(String(me.components.posysseus.properties.styles.left).replace("%", "")) + 3 / 1024; //3;
        var top = Number(String(me.components.posysseus.properties.styles.top).replace("%", "")) - 0;

        top = Math.sin(left * 0.0034 + this.currenty) * 30 + this.currenty;
    }

    me.components.posysseus.properties.styles.left = left / 1024 + "%";
    me.components.posysseus.properties.styles.top = top / 800 + "%";
    me.components.posysseus.reStyle();

    if (left > 1030)
        me.surfing = false;

    setTimeout(me.movePosysseus, 10, me.id);
}

legacy.close = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.cameraImage.properties.attributes.src = "";
    me.components.cameraImage.reAttribute();

    window.clearTimeout(me.updateImageId);

    me.visible = false;
    me.removeMe();

    log.add(3, "Info", "Screen saver disabled", "");

    POS.sessions.hideCurrentSession();
    POS.events.applyTS = true;
}

legacy.newPosition = function(width, height, maxwidth, maxheight) {
    var maxLeft = maxwidth - width;
    var maxTop = maxheight - height;

    var newLeft = getRandomNumber(0, maxLeft);
    var newTop = getRandomNumber(0, maxTop);

    return Array(newLeft, newTop);
}


function CScreenSaverScreen({ bridge }) {
  // Dieselbe Fallunterscheidung wie im Legacy-prepare: ist als
  // Bildschirmschoner ein VIDEO eingestellt, baut prepare() eine eigene
  // <div>/<video>-Schicht ueber jQuery an den body und der Screen selbst
  // bleibt leer - dann gibt es auch hier keine Bilder.
  const video = (POS.EnvProperties['SCREENSAVERIMAGE'] || '').indexOf('video') > -1;
  if (video) return null;

  // Styles und src wie in etc/layout/LYT_screenSaver.xml (+ den
  // CImage-Voreinstellungen). properties.styles bekommt DIESELBEN Werte:
  // rePosition()/movePosysseus() verschieben die Bilder ueber reStyle().
  const kamera = { position: 'absolute', width: '100%', height: '100%' };
  const logo = { position: 'absolute', visibility: 'hidden', width: '34%', height: '44.6%' };

  return (
    <>
      <img {...bridge.el('0', 'CImage', { proto: CImage.prototype, properties: { styles: { ...kamera } } })}
           className="CImage" src=" " style={kamera} />
      <img {...bridge.el('1', 'CImage', { proto: CImage.prototype, properties: { styles: { ...logo } } })}
           // Bis 26.8.2026 wanderte hier das POSysseus-Logo. Der Altname soll
           // nirgends mehr vorkommen; statt das Bild ersatzlos zu streichen
           // (der Bildschirmschoner haette dann ein kaputtes Bild gezeigt)
           // wandert jetzt das Logo des Geschaefts.
           className="CImage" src="lib/img/customerlogo.gif" style={logo} />
    </>
  );
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CScreenSaver(id, session) {
//     this.construct(id, "CScreenSaver",session);
// 
//     this.collector = true;
//     this.htmlType = "div";
// 
//     this.cameraImage = null;
//     this.posysseus = null;
//     this.visible = false;
// 
//     this.properties = {
//         cameraImage: {},
//         posysseus: {},
//         styles: {
//             backgroundColor: "#000000",
//             position: "absolute",
//             width: "100vw",
//             height: "100vh",
//             left: "0px",
//             top: "-7%",
//             zIndex: "20"
//         },
//         events: {},
//         attributes: {}
//     }
// 
//     this.surfing = false;
//     this.currenty = 0;
//     this.turnImage = null;
// }
export const CScreenSaver = defineReactScreen({
  className: 'CScreenSaver',
  addclass: 'CScreenSaver',
  htmlType: 'div',
  Screen: CScreenSaverScreen,
  // Der Legacy-Konstruktor baut ein eigenes properties-Objekt (mit
  // cameraImage/posysseus-Unterbaeumen) - deshalb kommt es komplett aus
  // fields() statt aus rootStyles.
  fields: () => ({
    collector: true,
    cameraImage: null,
    posysseus: null,
    visible: false,
    properties: {
      cameraImage: {},
      posysseus: {},
      styles: {
        backgroundColor: '#000000',
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        left: '0px',
        top: '-7%',
        zIndex: '20',
      },
      events: {},
      attributes: {},
    },
    surfing: false,
    currenty: 0,
    turnImage: null,
  }),
  // Das Legacy-prepare laeuft hier - VOR create(): es setzt die Entsperr-
  // Events auf die Wurzel (onMousedown/onKeypress -> close), und die muessen
  // stehen, bevor die Bridge das Wurzel-Element erzeugt.
  prepare(bridge) {
    return legacy.prepare.call(bridge);
  },
  // Nach dem Mount: die XML-Namen wieder anlegen, auf die die Methoden
  // zugreifen (close/updateImage/rePosition arbeiten ueber
  // components.cameraImage bzw. components.posysseus), und erst DANN das
  // Kamerabild nachziehen - im Legacy stand dieser Aufruf am Ende von
  // prepare(), wo die Bilder inzwischen noch gar nicht existieren.
  mountLegacy(bridge) {
    if ((POS.EnvProperties['SCREENSAVERIMAGE'] || '').indexOf('video') > -1) return;
    bridge.nameComponent('0', 'cameraImage');
    bridge.nameComponent('1', 'posysseus');
    bridge.updateImage(bridge.id);
  },
  legacyMethods: legacy,
});
